import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createPhysician = createAsyncThunk(
  "physician/physicianRegister",
  async (data, { rejectWithValue }) => {
    try {
      const dataForm = new FormData();
      Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
          data[key].forEach((item) => dataForm.append(key, item));
        } else {
          dataForm.append(key, data[key]);
        }
      });

      const response = await axios.post(
        "/physician/physicianRegister",
        dataForm,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: data.token,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAllPhysician = createAsyncThunk(
  "physician/getAllPhysician",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/physician/getAllPhysician", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const editPhysician = createAsyncThunk(
  "physician/editPhysician",
  async (data, { rejectWithValue }) => {
    try {
      const dataForm = new FormData();
      dataForm.append("physicianId", data.physicianId);
      dataForm.append("userId", data.userId || "");
      for (const [key, value] of Object.entries(data.updatedData)) {
        if (Array.isArray(value)) {
          value.forEach((item) =>
            dataForm.append(`updatedData[${key}][]`, item),
          );
        } else {
          dataForm.append(`updatedData[${key}]`, value);
        }
      }
      const response = await axios.put("/physician/editPhysician", dataForm, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deletedPhysician = createAsyncThunk(
  "physician/deletedPhysician",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/physician/clinicDisassociation",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPhysicianById = createAsyncThunk(
  "physician/getPhysicianById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/physician/getPhysicianById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

/* To associate with clinic */
export const associateClinic = createAsyncThunk(
  "physician/associateClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physician/updatePhysicianAssociation",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

/* To associate with clinic */
export const disassociateClinic = createAsyncThunk(
  "physician/disassociateClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/physician/clinicDisassociation",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPhysicianByClinicId = createAsyncThunk(
  "physician/getPhysicianByClinicId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physician/getPhysicianByClinicId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPhysicianTimeSlots = createAsyncThunk(
  "physician/getPhysicianTimeSlot",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physician/getPhysicianTimeSlot",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const updatePhysicianSlotStatus = createAsyncThunk(
  "physician/updatePhysicianSlotStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/physician/updatePhysicianSlotStatus",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const getPhysicianInfo = createAsyncThunk(
  "physician/getPhysicianInfo",
  async (clinicData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physician/getPhysicianInfo",
        clinicData,
        {
          headers: {
            "Content-Type": "application/json",
            token: clinicData.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
const initialState = {
  loading: false,
  physician: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  limit: 9,
  physicianInfo: [],
  physicianInfoNew: [],
  physicianTimeSlot: null,
  getPhysicianDetailsByClinic: [],
  createPhysicianSuccessMessage: null,
  createPhysicianErrorMessage: null,
  updatePhysicianSuccessMessage: null,
  updatePhysicianErrorMessage: null,
  deletePhysicianSuccessMessage: null,
  deletePhysicianErrorMessage: null,
  associateClinicSuccessMessage: null,
  associateClinicErrorMessage: null,
  disassociateClinicSuccessMessage: null,
  disassociateClinicErrorMessage: null,
  updatePhysicianSlotStatusSuccessMessage: null,
  updatePhysicianSlotStatusErrorMessage: null,
  getPhysicianInfoSuccessMessage: null,
  getPhysicianInfoErrorMessage: null,
};

const physicianSlice = createSlice({
  name: "physician",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageLimit: (state, action) => {
      state.limit = action.payload;
      state.currentPage = 1; // Reset to page 1 when limit changes
    },
    resetCreateMessages: (state) => {
      state.createPhysicianSuccessMessage = null;
      state.createPhysicianErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updatePhysicianSuccessMessage = null;
      state.updatePhysicianErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deletePhysicianSuccessMessage = null;
      state.deletePhysicianErrorMessage = null;
    },
    resetAssociateClinicMessages: (state) => {
      state.associateClinicSuccessMessage = null;
      state.associateClinicErrorMessage = null;
    },
    resetDisassociateClinicMessages: (state) => {
      state.disassociateClinicSuccessMessage = null;
      state.disassociateClinicErrorMessage = null;
    },
    resetUpdatePhysicianSlotStatus: (state) => {
      state.updatePhysicianSlotStatusSuccessMessage = null;
      state.updatePhysicianSlotStatusErrorMessage = null;
    },
    resetgetPhysicianInfo: (state) => {
      state.getPhysicianInfoSuccessMessage = null;
      state.getPhysicianInfoErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPhysician.pending, (state) => {
        state.loading = true;
        state.createPhysicianSuccessMessage = null;
        state.createPhysicianErrorMessage = null;
      })
      .addCase(createPhysician.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createPhysicianErrorMessage = action.payload.result.message;
        } else {
          state.createPhysicianSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createPhysician.rejected, (state, action) => {
        state.loading = false;
        state.createPhysicianErrorMessage = action.payload.result.message;
      })
      .addCase(getAllPhysician.pending, (state, action) => {
        state.loading = true;
      })
.addCase(getAllPhysician.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
          state.physician = [];
          state.totalCount = 0; // Reset count if none found
        } else {
          // --- UPDATE THIS TO MAP BACKEND RESPONSE ---
          state.physician = action.payload.result.list;
          state.totalCount = action.payload.result.totalCount;
          state.totalPages = action.payload.result.totalPages;
          state.currentPage = action.payload.result.currentPage;
        }
      })
      .addCase(getAllPhysician.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(editPhysician.pending, (state) => {
        state.loading = true;
        state.updatePhysicianSuccessMessage = null;
        state.updatePhysicianErrorMessage = null;
      })
      .addCase(editPhysician.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updatePhysicianErrorMessage = action.payload.result.message;
        } else {
          state.updatePhysicianSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(editPhysician.rejected, (state, action) => {
        state.loading = false;
        state.updatePhysicianErrorMessage = action.payload.result.message;
      })
      .addCase(deletedPhysician.pending, (state) => {
        state.loading = true;
        state.deletePhysicianSuccessMessage = null;
        state.deletePhysicianErrorMessage = null;
      })
      .addCase(getPhysicianById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPhysicianById.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.physicianInfo = action.payload.result.list;
      })
      .addCase(getPhysicianById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deletedPhysician.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deletePhysicianErrorMessage = action.payload.result.message;
        } else {
          state.deletePhysicianSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deletedPhysician.rejected, (state, action) => {
        state.loading = false;
        state.deletePhysicianErrorMessage = action.payload.result.message;
      })
      .addCase(associateClinic.pending, (state) => {
        state.loading = true;
        state.associateClinicSuccessMessage = null;
        state.associateClinicErrorMessage = null;
      })
      .addCase(associateClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.associateClinicErrorMessage = action.payload.result.message;
        } else {
          state.associateClinicSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(associateClinic.rejected, (state, action) => {
        state.loading = false;
        state.associateClinicErrorMessage = action.payload.result.message;
      })
      .addCase(disassociateClinic.pending, (state) => {
        state.loading = true;
        state.disassociateClinicSuccessMessage = null;
        state.disassociateClinicErrorMessage = null;
      })
      .addCase(disassociateClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.disassociateClinicErrorMessage = action.payload.result.message;
        } else {
          state.disassociateClinicSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(disassociateClinic.rejected, (state, action) => {
        state.loading = false;
        state.disassociateClinicErrorMessage = action.payload.result.message;
      })
      .addCase(getPhysicianByClinicId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPhysicianByClinicId.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.getPhysicianDetailsByClinic = action?.payload?.result?.list;
      })
      .addCase(getPhysicianByClinicId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getPhysicianTimeSlots.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPhysicianTimeSlots.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.physicianTimeSlot = action?.payload?.result?.list;
      })
      .addCase(getPhysicianTimeSlots.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePhysicianSlotStatus.pending, (state) => {
        state.loading = true;
        state.updatePhysicianSlotStatusSuccessMessage = null;
        state.updatePhysicianSlotStatusErrorMessage = null;
      })
      .addCase(updatePhysicianSlotStatus.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updatePhysicianSlotStatusErrorMessage =
            action.payload.result.message;
        } else {
          state.updatePhysicianSlotStatusSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(updatePhysicianSlotStatus.rejected, (state, action) => {
        state.loading = false;
        state.updatePhysicianSlotStatusErrorMessage =
          action.payload.result.message;
      })
      .addCase(getPhysicianInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPhysicianInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.physicianInfoNew = action.payload.result.list;
        } else {
          state.getPhysicianInfoErrorMessage = action.payload.result.message;
        }
      })
      .addCase(getPhysicianInfo.rejected, (state, action) => {
        state.loading = false;
        state.getPhysicianInfoErrorMessage = action.payload || "Failed to fetch clinic info";
      });
  },
});

export const {
  setCurrentPage,
  setPageLimit,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
  resetAssociateClinicMessages,
  resetDisassociateClinicMessages,
  resetUpdatePhysicianSlotStatus,
} = physicianSlice.actions;
export default physicianSlice.reducer;
